import type { UnionToTuple } from "type-fest";
import { z } from "zod";

import { zOutSchema, zRes401 } from "./common";

import type { NotificationServicePorts } from "~/entities/notification";
import { Request, Response } from "~/shared/api";

const zRes200 = Response.Schema.zSuccessful(
  200,
  Request.Pagination.Page.zSchema(zOutSchema).extend({
    unreadCount: z.number().int().nonnegative(),
  }),
);
type Res200 = z.infer<typeof zRes200>;

const zRes = Response.Schema.zAggregated([zRes200, zRes401]);
type Res = z.infer<typeof zRes>;

const zFieldsToSortBy = z.enum(
  Object.values(zRes200.shape.body.shape.data.shape.items.element.keyof().Enum) as UnionToTuple<
    keyof Res200["body"]["data"]["items"][number]
  >,
);
const FieldsToSortBy = zFieldsToSortBy.Enum;
type FieldsToSortBy = z.infer<typeof zFieldsToSortBy>;

const MAP_OF_FIELDS_TO_SORT_BY: Record<
  NotificationServicePorts.ProviderIos.GetPaginated.FieldsToSortBy,
  FieldsToSortBy
> = {
  id: "id",
  isRead: "isRead",
  createdAt: "createdAt",
};

export { FieldsToSortBy, MAP_OF_FIELDS_TO_SORT_BY, zFieldsToSortBy, zRes };
export type { Res };
